import { render, staticRenderFns } from "./CreateVideoModal.vue?vue&type=template&id=5ede8607&"
import script from "./CreateVideoModal.vue?vue&type=script&lang=ts&"
export * from "./CreateVideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateVideoModal.vue?vue&type=style&index=0&id=5ede8607&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports